import { render, staticRenderFns } from "./TopupChatPage.vue?vue&type=template&id=5e83ea52&scoped=true&"
import script from "./TopupChatPage.vue?vue&type=script&lang=js&"
export * from "./TopupChatPage.vue?vue&type=script&lang=js&"
import style0 from "./TopupChatPage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TopupChatPage.vue?vue&type=style&index=1&id=5e83ea52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e83ea52",
  null
  
)

export default component.exports